import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import GridCard from 'components/GridCard';
import DashboardFlightsCardUpdateStatus from 'components/DashboardFlightsCardUpdateStatus';

import { DashboardFlightsCard_flightsInfo$key } from '__generated__/DashboardFlightsCard_flightsInfo.graphql';
import { DashboardFlightsCard_settings$key } from '__generated__/DashboardFlightsCard_settings.graphql';

type Props = {
  flightsInfo: DashboardFlightsCard_flightsInfo$key;
  settings: DashboardFlightsCard_settings$key;
};

const DashboardFlightsCard: FC<Props> = props => {
  const flightsInfo = useFragment(
    graphql`
      fragment DashboardFlightsCard_flightsInfo on DashboardFlightsInfo {
        total

        ...DashboardFlightsCardUpdateStatus_flightsInfo
      }
    `,
    props.flightsInfo
  );

  const settings = useFragment(
    graphql`
      fragment DashboardFlightsCard_settings on Settings {
        ...DashboardFlightsCardUpdateStatus_settings
      }
    `,
    props.settings
  );

  const { total } = flightsInfo;

  return (
    <GridCard>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Skrydžiai
        </Typography>

        <Box sx={{ display: 'flex', mb: 1 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Link href={'/flights?expired=0'}>Visi skrydžiai</Link>
          </Box>

          <Box>
            <Link href={'/flights?expired=0'}>{total}</Link>
          </Box>
        </Box>

        <Divider sx={{ mb: 1 }} />

        <DashboardFlightsCardUpdateStatus
          flightsInfo={flightsInfo}
          settings={settings}
        />
      </CardContent>
    </GridCard>
  );
};

export default DashboardFlightsCard;
